if (!customElements.get('wlsn-query-params')) {
    class WLSNQueryParams extends HTMLElement {
      constructor() {
        super();
  
        this.classes = {
          queryParams: 'js-wlsn-query-param',
        };
  
        this.elements = {
          queryParams: this.querySelectorAll(`.${this.classes.queryParams}`),
        };
      }
  
      connectedCallback() {
        const items = this.elements.queryParams;
        if (!items.length) return;
        const pageParams = new URLSearchParams(window.location.search);
        if (![...pageParams.keys()].length) return;

        items.forEach(el => {
          const target = el.dataset.target;
          if (!target) return;
  
          document.querySelectorAll(`a[href*="${target}"]`).forEach(link => {
            try {
              const url = new URL(link.href);
  
              pageParams.forEach((value, key) => {
                if (!url.searchParams.has(key)) {
                  url.searchParams.set(key, value);
                }
              });
  
              link.href = url.toString();
            } catch (e) {
              console.error(e);
            }
          });
        });
      }
    }
  
    customElements.define('wlsn-query-params', WLSNQueryParams);
  }
  